import { render, staticRenderFns } from "./ImportIcon.vue?vue&type=template&id=6617ae99"
import script from "./ImportIcon.vue?vue&type=script&lang=ts"
export * from "./ImportIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports